document.addEventListener("DOMContentLoaded", () => {
  const links = document.querySelectorAll(".js-go-to-section");
  if (!links.length) return;

  // OFFSETY
  const getScrollOffset = (id) =>
    id === "contacts" ? 0 : window.innerHeight * 0.12;

  const getActiveEarlyOffset = () => window.innerHeight * 0.6;

  const getHeaderOffset = () => {
    const header =
      document.querySelector(".shopify-section-header, .js-header, header");
    return header ? header.getBoundingClientRect().height : 0;
  };

  const getTargetEl = (id) => {
    const section = document.getElementById(id);
    if (!section) return null;
    return section.querySelector(".js-parallax-animation") || section;
  };

  const getScrollTopForEl = (el) => {
    const rect = el.getBoundingClientRect();
    return rect.top + window.scrollY;
  };

  const sections = [...links]
    .map((link) => {
      const href = link.getAttribute("href") || "";
      if (!href.startsWith("#")) return null;

      const id = href.slice(1);
      const anchorEl = getTargetEl(id);
      if (!anchorEl) return null;

      return { id, link, anchorEl };
    })
    .filter(Boolean);

  if (!sections.length) return;

  // CLICK
  links.forEach((link) => {
    link.addEventListener("click", (e) => {
      const href = link.getAttribute("href") || "";
      if (!href.startsWith("#")) return;

      e.preventDefault();

      const targetID = href.slice(1);
      const s = sections.find((x) => x.id === targetID);
      if (!s) return;

      const targetTop =
        getScrollTopForEl(s.anchorEl) -
        getHeaderOffset() -
        getScrollOffset(targetID);

      window.scrollTo({
        top: Math.max(0, Math.round(targetTop)),
        behavior: "smooth",
      });
    });
  });

  // ACTIVE
  const updateActiveLink = () => {
    const triggerY =
      window.scrollY +
      getHeaderOffset() +
      getActiveEarlyOffset();

    let active = sections[0];

    for (let i = 0; i < sections.length; i++) {
      const s = sections[i];
      const top = getScrollTopForEl(s.anchorEl);
      if (top <= triggerY) active = s;
      else break;
    }

    sections.forEach((s) => {
      s.link.classList.toggle("active", s === active);
    });
  };

  let ticking = false;
  const onScrollOrResize = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      updateActiveLink();
    });
  };

  updateActiveLink();
  window.addEventListener("scroll", onScrollOrResize, { passive: true });
  window.addEventListener("resize", onScrollOrResize);
});



(() => {
  document.addEventListener('DOMContentLoaded', () => {
    const root = document.documentElement;
    const toggleBtn = document.querySelector('.js-theme-toggle');

    if (!root || !toggleBtn) return;

    const savedTheme = localStorage.getItem('theme');

    if (savedTheme) {
      root.setAttribute('data-theme', savedTheme);
    } else {
      const prefersDark = window.matchMedia &&
        window.matchMedia('(prefers-color-scheme: dark)').matches;
      root.setAttribute('data-theme', prefersDark ? 'dark' : 'light');
    }

    const toggleTheme = () => {
      const current = root.getAttribute('data-theme') || 'light';
      const next = current === 'light' ? 'dark' : 'light';
      root.setAttribute('data-theme', next);
      localStorage.setItem('theme', next);
    };

    toggleBtn.addEventListener('click', toggleTheme);
  });
})();

document.addEventListener("DOMContentLoaded", () => {
  const logos = document.querySelectorAll(".top-logo, .bottom-logo");

  logos.forEach(logo => {
    logo.addEventListener("click", (e) => {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    });
  });
});

document.addEventListener('click', function (e) {
  const trigger = e.target.closest('.js-get-email');
  if (!trigger) return;

  e.preventDefault();

  const DEFAULT_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="260" height="18" viewBox="0 0 260 18" role="img" aria-label="Email contact" style="user-select:none;-webkit-user-select:none"><text x="50%" y="14" text-anchor="middle" font-family="Archivo Narrow, Helvetica, sans-serif" font-size="14" fill="currentColor" pointer-events="none"><tspan>g</tspan><tspan>l</tspan><tspan>a</tspan><tspan>s</tspan><tspan dx="2">@</tspan><tspan dx="2">g</tspan><tspan>l</tspan><tspan>a</tspan><tspan>s</tspan><tspan dx="1">o</tspan><tspan>p</tspan><tspan>t</tspan><tspan>i</tspan><tspan>c</tspan><tspan>i</tspan><tspan>a</tspan><tspan>n</tspan><tspan dx="1">.</tspan><tspan>c</tspan><tspan>o</tspan><tspan>m</tspan></text></svg>';

  const svgCode = trigger.getAttribute('data-svg-code') || DEFAULT_SVG;

  const temp = document.createElement('textarea');
  temp.innerHTML = svgCode;
  const decodedSVG = temp.value;

  trigger.outerHTML = decodedSVG;
});